export default __webpack_public_path__ + "static/media/cmu.2312bed9.jpg";